import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

/**
 * Topbar button that toggles between light and dark themes.
 * The choice is persisted to localStorage by next-themes.
 */
export function ThemeToggle() {
    const { t } = useTranslation();
    const { resolvedTheme, setTheme } = useTheme();
    const [mounted, setMounted] = useState(false);

    // Avoid rendering theme-dependent UI until mounted (resolvedTheme is undefined on first paint).
    useEffect(() => setMounted(true), []);

    const isDark = resolvedTheme === "dark";

    return (
        <Button
            variant="ghost"
            size="icon"
            className="size-8 text-muted-foreground hover:text-foreground"
            onClick={() => setTheme(isDark ? "light" : "dark")}
            tooltip={t("topbar.toggleTheme")}
            aria-label={t("topbar.toggleTheme")}
        >
            {mounted && isDark ? <Sun /> : <Moon />}
        </Button>
    );
}
